/**
 * GL-7 student self-consent API client (wire-contract rows 14–16,
 * docs/gl-api-wire-contract.md in QLearn-service). Reuses the shared GL
 * transport (gl-shared/gl-fetch) — same /qlearn context prefix and typed-error
 * mapping as every other /gl caller — since these ARE /gl routes. No userId ever
 * rides a request: the subject is always the authenticated principal (self-only,
 * spec D1). While the server is dark it answers a uniform 404 to all three,
 * which glFetch maps to glError "unavailable"; and no surface mounts unless the
 * FE flag is on (gl-consent-audience.js).
 */
import { glFetch } from "../gl-shared/gl-fetch";

// Row 16 — GET /gl/consent -> {member, consentVersion, grantedAt} (self).
export const getGlConsent = () => glFetch("/gl/consent");

// Row 14 — POST /gl/consent/grant {consentVersion}. The version echoes the copy
// the user was shown; the server rejects a stale version (400) so a grant is
// never recorded against copy the user did not see.
export const grantGlConsent = (consentVersion) =>
  glFetch("/gl/consent/grant", { method: "POST", body: { consentVersion } });

// Row 15 — POST /gl/consent/revoke (no body). The server stamps every active
// membership row AND erases the caller's GL cards in the same request (D3).
export const revokeGlConsent = () =>
  glFetch("/gl/consent/revoke", { method: "POST" });
